import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const CompanyModule = {
  namespaced: true,
  state: {
    selCompany: null
  },
  getters,
  actions,
  mutations
}

export default CompanyModule
